import React, { Component } from "react";
import ReactDOM from 'react-dom';
import axios from "axios";
import SimplePagination from "./SimplePagination";
import { getErrorsMessage, getSuccessMessage } from '../utils.js';
import { LangContext } from "../LangContext.jsx";
class CostCenterPanel extends Component {
    static contextType = LangContext;
    constructor(props) {
        super();
        this.state = {
            costCenters: [],
            dates: [],
            search:'',
            page: 1,
            total: 0,
            maxRecords: props.top,
        };
        this.handleChange = this.handleChange.bind(this);
        this.updateCurrentPage = this.updateCurrentPage.bind(this);
    }

    componentDidMount() {
        this.getCostCenters()
        this.getData()
    }

    handleChange(e){
        this.setState({costCenters: [], search: e.target.value, page: 1}, function () {
            this.getCostCenters();
        });
    }

    updateCurrentPage(page){
        this.setState({page: page}, function () {
            this.getCostCenters();
        });
    }

    async delete(costCenter) {
        const { lang } = this.context; 
        swal.fire({
            text: lang.get('messages.estas_seguro_que_deseas_eliminar_este_centro_de_costos'),
            showCancelButton: true,
            icon: "question",
            buttonsStyling: false,
            confirmButtonText: lang.get('messages.continuar'),
            cancelButtonText: lang.get('messages.cancelar'),
            customClass: {
                confirmButton: "btn font-weight-bold btn-danger",
                cancelButton: "btn font-weight-bold btn-secondary"
            }
        }).then((result) => {
            if (result.isConfirmed) {
                this.deleteCostCenter(costCenter.id);
            }
        });
    }

    deleteCostCenter = (id) => {
        const { lang } = this.context; 
        window.blockUI(lang.get('messages.procesando')); 
        axios.delete(
            'api/cost_centers/' + id,
            {},
            {
                "headers": {
                    "content-type": "application/json",
                },
            }
        ).then((response) => {
            window.unblockUI();
            this.getCostCenters();
            swal.fire({
                text: getSuccessMessage(response),
                icon: "success",
                buttonsStyling: false,
                confirmButtonText: lang.get('messages.aceptar'),
                customClass: {
                    confirmButton: "btn font-weight-bold btn-primary"
                },
                timer: 3000
            });
        })
        .catch((error) => {
            window.unblockUI();
            swal.fire({
                text: lang.get('messages.algo_salio_mal_intenta_de_nuevo'),
                icon: "error",
                buttonsStyling: false,
                confirmButtonText:lang.get('messages.aceptar'),
                customClass: {
                    confirmButton: "btn font-weight-bold btn-primary"
                }
            });
        });
    }

    async getCostCenters(){
        var url = '/api/cost_centers/list_filter';
        const query = new URLSearchParams();
        query.append('page', this.state.page)
        query.append('maxRecords', this.state.maxRecords)
        if(this.state.search!=''){
            query.append('search', this.state.search)
        }
        const qs = query.toString();
        const res = await axios.get(url+`?${qs}`);
        const data = res.data.data;
        this.setState({costCenters: data, total: res.data.total});
    }

    async getData(){
        var url = '/api/profiles/data/data';
        const res = await axios.get(url);
        const data = res.data;
        this.setState({dates:  res.data, total: res.data.total});
    }

    render() {
        const { lang } = this.context; 
        return (
        <>
            <div className="card card-custom gutter-b my-5">
                <div className="card-header border-0 pt-6">
                    <h3 className="card-title align-items-start flex-column">
                        <span className="card-label font-weight-bolder font-size-h4 text-dark-75">{lang.get('messages.centros_de_costos')}</span>
                        <span className="text-muted mt-3 font-weight-bold font-size-lg">{this.state.total} {lang.get('messages.centros_de_costos_disponibles')}</span>
                    </h3>
                    <div className="card-toolbar">
                        <div>
                            {this.props.dashboard=="false" &&
                                <div className="input-icon">
                                    <input
                                        style={{width: '400px'}}
                                        onChange={this.handleChange}
                                        name="search"
                                        type="text"
                                        className="form-control"
                                        placeholder={lang.get('messages.buscar_centros_de_costos')} />
                                    <span>
                                        <i className="flaticon2-search-1 text-primary icon-md"></i>
                                    </span>
                                </div>
                            }
                        </div>
                    </div>
                </div>
                <div className="card-body pt-5">
                    <table className="table">
                        <thead>
                            <tr>
                                <th className="border-0">{lang.get('messages.nombre_del_centro_de_costo')}</th>
                                <th className="border-0"></th>
                            </tr>
                        </thead>
                        <tbody>
                        {this.state.costCenters.map((o, i) => {
                            return <tr key={i}>
                                <td className="p-5">
                                    <div className="d-flex align-items-center ">
                                        <div className="symbol symbol-40 symbol-white">
                                            <i className="flaticon2-location text-primary mr-3"></i>
                                        </div>
                                        <div className="d-flex flex-column flex-grow-1">
                                            <a href={"/cost_centers/" + o.id + "/edit"} className={"text-dark-75 font-weight-bolder text-hover-primary font-size-lg " + (o.active==0 ? "text-muted" : "")}>
                                                {o.name}
                                            </a>
                                            {o.active == 0 ? <span style={{ width : "60px" }} className="label label-sm label-light-dark label-inline font-weight-bold"><span className="font-size-xs">Borrador</span></span>: '' }
                                        </div>
                                    </div>
                                </td>
                                <td class="text-right">
                                    { ( this.props.permissions.cost_centers.includes('all') || this.props.permissions.cost_centers.includes('delete') ) &&
                                    <button onClick={()=>{ this.delete(o) }} className="btn btn-xs btn-icon btn-light-secondary mr-4">
                                        <i className="flaticon-delete fw-normal text-primary"></i>
                                    </button>
                                    }
                                    { ( this.props.permissions.cost_centers.includes('all') || this.props.permissions.cost_centers.includes('edit') ) &&
                                        <a href={"/cost_centers/" + o.id + "/edit"}>
                                            <button className="btn btn-xs btn-icon btn-light-secondary mr-4">
                                                <i className="flaticon2-edit text-primary"></i>
                                            </button>
                                        </a>
                                    }
                                    <a href={"/cost_centers/" + o.id }>
                                        <button className="btn btn-xs btn-icon btn-light-secondary mr-4">
                                            <i className={"flaticon2-right-arrow icon-sm " + (o.active==0 ? "text-muted" : "text-primary")}></i>
                                        </button>
                                    </a>
                                </td>
                            </tr>
                        })}
                        </tbody>
                    </table>
                </div>
                {this.state.total > this.state.maxRecords && this.props.dashboard=="false" &&
                    <SimplePagination
                    updateCurrentPage={this.updateCurrentPage}
                    currentPage={this.state.page}
                    totalFiles={this.state.total}
                    split={this.state.maxRecords} />
                }
            </div>
            </>
        );
    }
}

export default CostCenterPanel;

if (document.getElementById('CostCenterPanel')) {
    ReactDOM.render(<CostCenterPanel />, document.getElementById('CostCenterPanel'));
}
